import { useDispatch } from 'react-redux';

import { languageActions } from 'i18n';

const MOBILE_APP_VISITOR_KEY = 'isMobileAppVisitor';
const SHOW_STATS = 'showStatistics';

function clearMobileAppVisitor() {
  localStorage.removeItem(MOBILE_APP_VISITOR_KEY);
}

function clearShowStats() {
  localStorage.removeItem(SHOW_STATS);
}

function clearSessionAnnouncements() {
  Object.keys(sessionStorage).forEach((key) => {
    if (key.includes('announcement')) {
      sessionStorage.removeItem(key);
    }
  });
}

export function clearPendingReviewQueueState() {
  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith('prq-')) {
      sessionStorage.removeItem(key);
    }
  });
}

export default function useLogoutCleanups() {
  const dispatch = useDispatch();

  const resetLanguageLocale = () => {
    dispatch(languageActions.resetLanguageLocale());
  };

  return [
    // Built-in cleanups
    clearMobileAppVisitor,
    clearShowStats,
    resetLanguageLocale,
    // Custom cleanups
    clearSessionAnnouncements,
    clearPendingReviewQueueState,
  ];
}
